module.exports = __webpack_public_path__ + "static/media/MoneyMagpie_grey.8e30ced8.webp";